const VISIBLE_ORDER_STATUSES = new Set([
  'pending_approval',
  'sent',
  'acknowledged',
  'attacking',
  'held',
  'rejected',
  'cancelled',
]);

export function raidControlTimelineMessageVisible(message, ordersById) {
  if (message?.type !== 'attack_order') return true;
  const orderId = String(message?.orderId || '').trim();
  const order = orderId ? ordersById?.get?.(orderId) || null : null;
  if (!order) return true;
  return VISIBLE_ORDER_STATUSES.has(String(order.status || ''));
}
